import { atom } from "recoil";

export const productsNonFreeEnabledState = atom<boolean>({
  key: "productsNonFreeEnabledState",
  default: false
})